import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import Labels from '../../Labels';
import classes from './index.module.scss';
export const FormError = function () {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={cn(classes["abuse-error-wrapper"])}><h5 className="headline-5">{Labels.FORM.error.title}</h5><p className="caption book">{Labels.FORM.error.details}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};